import { render } from "./SaveCandidate.vue?vue&type=template&id=e75f8a7a&scoped=true"
import script from "./SaveCandidate.vue?vue&type=script&lang=js"
export * from "./SaveCandidate.vue?vue&type=script&lang=js"

import "./SaveCandidate.vue?vue&type=style&index=0&id=e75f8a7a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e75f8a7a"]])

export default __exports__